import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import { i18nextPlugin } from "translation-check";

const pluginUrl =
  typeof window.myPluginSettings !== "undefined"
    ? window.myPluginSettings.pluginUrl
    : ".";

const language =
  typeof window.myPluginSettings !== "undefined"
    ? window.myPluginSettings.language
    : "nl";

i18n
  //By using 'initReactI18next', we pass the i18n instance to react-i18next which will make it available for all the components.
  .use(initReactI18next)
  .use(i18nextPlugin)
  .use(Backend)
  .init({
    lng: language,
    supportedLngs: ["fr", "nl"],
    fallbackLng: "nl",
    debug: false,
    detection: {
      order: [
        "querystring",
        "cookie",
        "navigator",
        "htmlTag",
        "localStorage",
        "path",
        "subdomain",
      ],
      caches: ["cookie"],
      lookupQuerystring: "lang",
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    ns: ["translation"],
    defaultNS: "translation",
    nsSeparator: ":",
    saveMissing: false,
    backend: {
      loadPath: `${pluginUrl}/locales/{{lng}}/translation.json`,
    },
  });

i18n.services.formatter.add("lowercase", (value, lng, options) => {
  return value.toLowerCase();
});

export default i18n;
